import { Skeleton } from "@/core/components/ui/skeleton";
import { Stack } from "@/core/components/ui/stack";
import { cn } from "@/core/utils/utils";

interface TextMessageListItemSkeletonProps {
  index: number;
}

export const TextMessageListItemSkeleton = ({
  index,
}: TextMessageListItemSkeletonProps) => (
  <Stack
    gap="sm"
    className="border-b border-stroke-tertiary px-4 py-3"
    fullWidth
  >
    <Stack direction="row" align="baseline">
      <Skeleton className="h-5 w-40 rounded-full" />
      <Skeleton className="h-4 w-24 rounded-full" />
    </Stack>
    <Skeleton
      className={cn("h-5 w-[400px] max-w-[800px]", index % 2 === 0 && "w-full")}
    />
    {index % 2 === 0 && <Skeleton className="h-5 w-[300px]" />}
  </Stack>
);
